import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, i18nIntl, isJSON, throwErrorEvent } from '../../lib/ep.js';

import Checkbox from '../builder/Checkbox';
import Model from '../builder/Model';
import { ProfileModule } from '../ui_items/Module.js';
import { useOwner } from '../context/context.js';

const PromotionShareAccepted = (props) => {
	const owner = useOwner();

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false) return null;

	const is_wl = (promotion.promo_type == '2') ? true : false;
	if(!is_wl) return null

	const parsedShareAccepted = isJSON(promotion.share_accepted) ? JSON.parse(promotion.share_accepted) : promotion.share_accepted || false; 
	const [ accept, setAccept ] = useState(parsedShareAccepted);

	const change = (k, v) => {
		$.post(getRemotedbUrl(`/promotions/save/${promotion.id}`), { share_accepted:v }, (r) => {
			(r.share_accepted != undefined) ? setAccept(r.share_accepted) : setAccept(false);
		}, 'JSON').fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});
	};

	return (
		<ProfileModule 
			title={{ label:"Your promotion on Easypromos' channels", icon:'knk-share' }}
			subtitle="If you would like your promotion to be featured as an example in our content publications (newsletters, articles, Social Networks, ebooks), grant us your permission and we will keep in mind."
		>
			<Model model={promotion} change={change}>
				<Checkbox
					name='share_accepted'
					_class={{ first:true }}
					value={(accept !== false) ? true : false}
					after_component={(accept !== false) ? <span>{`${i18n("Accepted on")} ${EPDateFormat(accept.date, 'LLLL')}`}</span> : null}
				>I accept that Easypromos may share this promotion through its channels.</Checkbox>
			</Model>
		</ProfileModule>
	);
}

export default injectIntl(PromotionShareAccepted);